import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';
import { render } from 'ia-react-core';
import logger from './utils/logger';
import ConfiguredApp from './app';

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');
const muoto = new FontFaceObserver('Muoto');

// Cancellation-only error suppression is registered earlier, in public/index.html,
// so it runs before the webpack-dev-server error overlay client (see that file for why).

Promise.all([
  montserrat.load(),
  openSans.load(),
  muoto.load(),
]).catch(() => {
  logger.warn('Fonts could not be loaded');
}).finally(() => {
  render(ConfiguredApp);
});
